import qs from "qs";

import { onBrowser } from "@kazoohr/helpers";

export const useCurrentWorkspace = (): string | undefined => {
  if (!onBrowser()) {
    return undefined;
  }

  // We can't use useLocation() here because useLocation() doesn't return the
  // host which is needed to extract the subdomain
  const { host, search } = window.location;

  const { workspace } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  if (workspace === "login") {
    return undefined;
  }

  if (typeof workspace === "string") {
    return workspace;
  }

  // Extract subdomain from host — requires at least 3 parts (sub.domain.tld)
  // Hosts like "localhost:8888" or "kazoohr.com" have fewer parts and no
  // subdomain
  const parts = host.split(".");
  if (parts.length >= 3) {
    const subdomain = parts[0];
    if (subdomain !== "login") {
      return subdomain;
    }
  }

  return undefined;
};
